import { assertIsNumberOrNull } from '../../../../helpers/numberHelpers';
import { UnitRoofElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitRoofElementFormModel';

export type CreateUpdateUnitRoofElementDto = {
  roofElementId: number | null;
  displayIndex: number;
  name: string;
  roofThermalTransmittance: number | null;
  skylightThermalTransmittance: number | null;
  defaultTemperatureAboveInDegreesCelsius: number | null;
};

export const mapUnitRoofElementFormModelToDto = (
  formModel: UnitRoofElementFormModel,
  displayIndex: number,
): CreateUpdateUnitRoofElementDto => ({
  roofElementId: formModel.roofElementId,
  displayIndex,
  name: formModel.name,
  roofThermalTransmittance: assertIsNumberOrNull(formModel.roofThermalTransmittance),
  skylightThermalTransmittance: assertIsNumberOrNull(formModel.skylightThermalTransmittance),
  defaultTemperatureAboveInDegreesCelsius: assertIsNumberOrNull(formModel.defaultTemperatureAboveInDegreesCelsius),
});
